import React, { useState } from "react";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import moment from "moment";

export const PayOffListing = (props) => {

    function filterByCurrentDate(data) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const filteredData = data.filter(item => {
          const monthDate = new Date(item.month);
          monthDate.setHours(0, 0, 0, 0);
          return monthDate >= currentDate;
      });
      return filteredData;
    }

  const filteredData = props && props.data && filterByCurrentDate(props.data);
  // console.log("filteredData",filteredData,props.data && props.data)
  return (
    <div style={{position:"relative",height:"100%",}}>
      <div className="cardHeadingDebt">Amortization of All Debts</div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          height:"90%",
          // height: "21rem",
          marginTop:"1rem"
        }}
      >
        {filteredData && filteredData.length > 0 ? (
          <div className="ContactTableConatier" style={{height:"100%"}}>
            <div style={{ maxHeight: "25rem" }}>
              <table className="ContactTable">
                <thead>
                  <tr className="ContactTable-Row">
                    <th className="ContactTable-data">Date</th>
                    <th className="ContactTable-data">Total Payment</th>
                    <th className="ContactTable-data">Principal</th>
                    <th className="ContactTable-data">Interest</th>
                    <th className="ContactTable-data">Remaining Balance</th>
                   
                  </tr>
                </thead>
                <tbody className="ContactTable-body">
                  {filteredData &&
                    filteredData.map((data, index) => (
                      <tr key={index} className="ContactTable-Row">
                        <td className="ContactTable-data">
                          {data.month ?
                            moment(data.month).format("MM-DD-YYYY") : "N/A" }
                        </td>
                        <td className="ContactTable-data">
                          {props.totalPaid && props.totalPaid && props.totalPaid.totalMonthlyPayment ? props.totalPaid.totalMonthlyPayment.toFixed(2) : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.principalPaid ? data.principalPaid : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.interestPayment ?  data.interestPayment : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.remainingBalance ? data.remainingBalance : "N/A"}
                        </td>
                       
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
            }}
          >
            No List to Show
          </div>
        )}
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
